export default {
  path: '/ratio-digital',
  meta: {
    title: '数字权益流水',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-digital`),
}



// WEBPACK FOOTER //
// ./src/views/RatioDidital/router.js